<template>
  <div>
    <div class="step3 mb-6">
      <div class="activeicon">
        <p class="font-bold text-sm text-dark mb-2">
          {{ $t('frontend_groovemail_sequences_edit_options') }}
        </p>
      </div>
      <div class="flex flex-no-wrap flex-col">
        <div class="w-full option-div">
          <p class="font-semibold text-base text-dark mb-2">
            {{ $t('frontend_groovemail_sequences_goto_redirect') }} :
          </p>
          <select
            :disabled="true"
            class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
          >
            <option>{{ this.localModel.currentflowname }}</option>
          </select>
          <div class="goto-sel my-2 relative">
            <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
            <select
              class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
              v-model="localModel.gotostep"
            >
              <option value="">
                {{ $t('frontend_groovemail_sequences_edit_select_step') }} ..
              </option>
              <option
                v-for="node in Object.keys(nodesPresent)"
                :key="nodesPresent[node].id"
                :value="nodesPresent[node].id"
              >
                {{ nodesPresent[node].id }} - {{ nodesPresent[node].name }}
              </option>
            </select>
          </div>
          <div class="goto-sel relative">
            <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
            <select
              class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
              v-model="localModel.gotoflow"
              :disabled="localModel.gotostep != '' ? false : true"
            >
              <option value="">
                {{ $t('frontend_groovemail_sequences_edit_select_flow') }}..
              </option>
              <option
                v-for="flow in flowSetting"
                :key="flow.id"
                :value="flow.id"
              >
                {{ flow.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue2-timepicker/dist/VueTimepicker.css';


// import icons
import DownIcon from '@/assets/images/icons/new/down_new.svg';

export default {
  name: 'SMSNode',
  props: {
    model: {
      required: true,
    },
  },
  data() {
    return {
      localModel: this.model,
      nodesPresent: [],
    };
  },

  components: {
    DownIcon,
  },

  computed: {
    flowSetting() {
      return [
        {
          id: 1,
          name: this.$t('frontend_groovemail_sequence_goto_flow_pause_option'),
        },
        {
          id: 2,
          name: this.$t(
            'frontend_groovemail_sequence_goto_flow_dont_pause_option'
          ),
        },
      ];
    },
  },

  mounted() {
    let reteNodes;
    if (this.localModel.retedata.nodes) {
      reteNodes = this.localModel.retedata.nodes;
    }
    Object.keys(reteNodes).forEach((ele) => {
      if (reteNodes[ele].name === 'Goto') {
        delete reteNodes[ele];
      }
    });
    this.nodesPresent = reteNodes;
  },
  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },
  },
};
</script>
